
function notify(object, title, text, color) {
    object.notify({
        position: "top-center",
        title,
        text,
        color
    });
}

export default {
    notifySuccess(object, text, title = 'Atenção') {
        notify(object, title, text, 'success')
    },

    /**
     * Notificação de Falha
     * @param {object} object this.$vs
     * @param {string} text texto a ser exibido
     * @param {string} title título da mensagem
     */
    notifyFail(object, text, title = 'Atenção') {
        notify(object, title, text, 'danger')
    },
}